export const DEFAULT_SORT_ORDER = "asc";
export const DEFAULT_SORT_BY = "date";

export const INITIAL_VISIT_FILTERS = {
  isTodayAndUpcoming: true,
} as const;
